import { useEffect, useState } from "react";

function useCountdown(targetTimestamp) {

    const calculateTimeLeft = () => {
        if (!targetTimestamp || Number.isNaN(Number(targetTimestamp))) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                completed: false,
                invalid: true,
            };
        }

        const now = Date.now();
        const difference = Number(targetTimestamp) - now;

        if (difference <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                completed: true,
                invalid: false,
            };
        }

        return {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / (1000 * 60)) % 60),
            seconds: Math.floor((difference / 1000) % 60),
            completed: false,
            invalid: false,
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

    useEffect(() => {
        setTimeLeft(calculateTimeLeft());
        if (!targetTimestamp || Number.isNaN(Number(targetTimestamp))) {
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetTimestamp]);

    const formatTimer = () => {
        if (!targetTimestamp || timeLeft.invalid) return "--";
        if (timeLeft.completed) return "Running";
        const parts = [];
        if (timeLeft.days > 0) parts.push(`${timeLeft.days}d`);
        if (timeLeft.hours > 0 || timeLeft.days > 0) {
            parts.push(`${timeLeft.hours}h`);
        }
        if (timeLeft.minutes > 0 || timeLeft.hours > 0 || timeLeft.days > 0 ) {
            parts.push(`${timeLeft.minutes}m`);
        }
        parts.push(`${timeLeft.seconds}s`);
        return parts.join(" ");
    };

    return {
        timeLeft,
        formatTimer,
    };
}

export default useCountdown;